<template>
    <div>
        <div class="page-content">
            <b-card footer-class="p-0" class="rounded-lg mt-4">
                <client-details-new v-if="settingLoaded" ref="detailForm" />

                <template v-slot:footer no-body>
                    <b-tabs card class="list" lazy>
                        <b-tab v-for="(tab, index) in tabs" :key="index">
                            <template v-slot:title>
                                <span class="px-1">
                                    <i :class="tab.icon"></i>
                                    {{ tab.title }}
                                </span>
                            </template>
                            <b-card-text style="min-height: 100px;">
                                <i>Not available.</i>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </template>
            </b-card>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import ClientDetailsNew from "@/components/client-details/details-new";
import unsavePrompt from "@/mixins/unsave-prompt.js";

export default {
    name: "clientNew",
    mixins: [unsavePrompt],
    components: {
        ClientDetailsNew
    },
    computed: {
        settingLoaded() {
            return !_.isEmpty(this.$store.getters["setting"]);
        },
        form_dirty() {
            return this.$refs.detailForm.isDirty();
        }
    },
    data() {
        return {
            keyComponent: 0,
            tabs: [
                {
                    icon: "cus-group",
                    title: "Relationships"
                },
                {
                    icon: "cus-vcard",
                    title: "Contact Details"
                },
                {
                    icon: "cus-folder-picture",
                    title: "Documents"
                },
                {
                    icon: "cus-money",
                    title: "Billing"
                },
                {
                    icon: "cus-comments",
                    title: "Communications"
                },
                {
                    icon: "cus-date",
                    title: "Appointments"
                },
                {
                    icon: "cus-clock",
                    title: "Reminders"
                },
                {
                    icon: "cus-note",
                    title: "Notes"
                },
                {
                    icon: "cus-bell",
                    title: "Tasks"
                }
            ]
        };
    }
};
</script>
